import {RouterModule, Routes} from '@angular/router';
import {CustomInteractionQueueConfigComponent} from './custom-interaction-queue-config/custom-interaction-queue-config.component';
import {AuthorizationCheck} from '../../auth/authorizationCheck';
import {ModuleWithProviders} from '@angular/core';
import {MasterPageComponent} from '../../master/masterpage.component';

const Config_Routes: Routes = [
  {
    path: 'configCustomQueue/:customId',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: CustomInteractionQueueConfigComponent }],
    canActivate: [AuthorizationCheck],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'newConfigCustomQueue',
    component: MasterPageComponent,
    children: [{ outlet: 'master', path: '', component: CustomInteractionQueueConfigComponent }],
    canActivate: [AuthorizationCheck],
    runGuardsAndResolvers: 'always'
  }
];

export const configRouting: ModuleWithProviders = RouterModule.forChild(Config_Routes);
